import type {UpdateSupplierFunctionFormPayload} from "./update-supplier-function.schema";

import {updateSupplierFunction} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {supplierFunctionKeys, supplierFunctionMutationKeys} from "../../../supplierFunction-keys";

export function updateSupplierFunctionMutationOptions(supplierFunctionId: string) {
  return mutationOptions({
    mutationFn: (payload: UpdateSupplierFunctionFormPayload) =>
      updateSupplierFunction(supplierFunctionId, payload),
    mutationKey: supplierFunctionMutationKeys.updateSupplierFunction,
    onSuccess: async (_data, _payload, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: supplierFunctionKeys.detail(supplierFunctionId)}),
        client.invalidateQueries({queryKey: supplierFunctionKeys.lists()}),
      ]);
    },
  });
}
